import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { IContribuyente } from './../../core/models/business-information/ibusiness-information';
import { convertDate } from './../../core/helpers/convert-date/convert-date';
import { environment } from '../../../environments/environment';
import { DateTimeService, FormatoFechaDateFns, UnidadTiempoDateFns } from 'src/app/core/utils/datetime.service';


@Component({
    selector: 'app-date-format', // Nombre del selector traducido
    templateUrl: './date-format.component.html',
    styleUrls: ['./date-format.component.scss'],
    standalone: false
})
export class DateFormatComponent implements OnInit {
  datosEmpresa: IContribuyente; // Nombre de la variable traducido
  maxFecha = new Date();
  minFecha = new Date();
  minFechaFin: Date | undefined;
  maxFechaFin = new Date();
  maxPeriodoInicial: Date | undefined;
  fechaAfiliaciones: Date;

  @Input() datos: any;

  formularioInfoBasica: FormGroup = new FormGroup({
    periodoInicial: new FormControl(''), // Nombres de los controles traducidos
    periodoFinal: new FormControl(''),
  });

  constructor(private almacenamientoLocal: LocalStorageService, 
              private dateTimeService: DateTimeService) {}

  ngOnInit() {
    this.formularioInfoBasica.get('periodoFinal').disable();
    this.datosEmpresa = this.almacenamientoLocal.getItemJSON(environment.LOCAL_STORAGE.BUSINESS_INFORMATION);

    const fechaConvertida = convertDate(this.datosEmpresa.fechaAfiliacion);
    this.fechaAfiliaciones = this.dateTimeService.parsearFecha(fechaConvertida, FormatoFechaDateFns.DD_MM_YYYY);
    

    if (this.fechaAfiliaciones.getFullYear() < 2014) {
      this.fechaAfiliaciones.setFullYear(2014);
      this.fechaAfiliaciones.setMonth(0);
    }

    this.minFecha = new Date(
      this.fechaAfiliaciones.getFullYear(),
      this.fechaAfiliaciones.getMonth(),
      1,
      0,
      0
    );

    const valorControl = this.dateTimeService.agregarUnidad(1, UnidadTiempoDateFns.Months, false, this.dateTimeService.newDate());

    this.maxPeriodoInicial = new Date(
      valorControl.getFullYear(),
      valorControl.getMonth(),
      valorControl.getDate(),
      23,
      59
    );

    this.formularioInfoBasica.get('periodoInicial').valueChanges.subscribe((fechaInicio: Date) => {
      if (fechaInicio) {
        this.formularioInfoBasica.get('periodoFinal').setValue('');
        this.formularioInfoBasica.get('periodoFinal').enable();
        this.minFechaFin = fechaInicio;
      }
    });
  }

  manejarAnioSeleccionado(controlNombre: string, anioNormalizado: moment.Moment) {
    let valorControl: Date = this.formularioInfoBasica.get(controlNombre).value
      ? this.dateTimeService.parsearFecha(this.formularioInfoBasica.get(controlNombre).value, FormatoFechaDateFns.DD_MM_YYYY)
      : this.dateTimeService.newDate();

    if (anioNormalizado) {
      valorControl.setFullYear(anioNormalizado.year());
    }

    this.formularioInfoBasica.get(controlNombre).setValue(valorControl);
  }

  manejarMesSeleccionado(
    controlNombre: string,
    mesNormalizado: moment.Moment,
    esFinal: boolean = false
  ) {
    let valorControl: Date = this.formularioInfoBasica.get(controlNombre).value
      ? this.dateTimeService.parsearFecha(this.formularioInfoBasica.get(controlNombre).value, FormatoFechaDateFns.DD_MM_YYYY)
      : this.dateTimeService.newDate();

    if (mesNormalizado) {
      valorControl.setMonth(mesNormalizado.month());
    }

    valorControl.setDate(1);

    if (esFinal) {
      valorControl = this.dateTimeService.agregarUnidad(1, UnidadTiempoDateFns.Months, false, valorControl);
    }

    this.formularioInfoBasica.get(controlNombre).setValue(valorControl);
  }
}